import { useState } from "react";
import { Gizmo } from "flowy-3-core";
import styled from "styled-components";
import { Button as AButton } from "antd";
import { Modal } from "antd";

const Button = styled(AButton)`
  marign: 5px 0;
  // width: 100%;
`;

type RegisterButtonProps = {
  gizmo: Gizmo;
};

const RegisterButton = ({ gizmo }: RegisterButtonProps) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const title = "Aviso de Privacidad";

  const handleButtonClick = async () => {
    setModalOpen(true);
  };

  const handleModalOk = async () => {
    window.location.href = "/#/sign_up";
  };
  const handleModalCancel = async () => {
    setModalOpen(false);
  };

  return (
    <>
      <Button onClick={handleButtonClick} type="primary">
        Regístrate
      </Button>
      <Modal
        open={modalOpen}
        title={title}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
      >
        <p>
          En cumplimiento a la Ley General de Protección de Datos Personales en
          Posesión de Sujetos Obligados y la Ley de Protección de Datos
          Personales en Posesión de Sujetos Obligados para el Estado de Quintana
          Roo; La Secretaria de Bienestar del Estado de Quintana Roo, a través
          de la Agencia de Seguridad Alimentaria, informa que es la responsable
          del tratamiento de los Datos Personales que nos proporcione para
          efecto de participar en el programa{" "}
          <span style={{ fontWeight: 900 }}>"Comemos Tod@s"</span>, los cuales
          estarán protegidos con fundamento en la legislación mencionada con
          antelación, y demás normativa aplicable a la materia.
          <br />
          <br />
          Para mayor detalle, usted puede consultar nuestro Aviso de Privacidad
          Integral en:
          <a
            target="_blank"
            rel="noreferrer"
            href="https://sebien.qroo.gob.mx/avisos-de-privacidad-de-la-sebien/"
          >
            https://sebien.qroo.gob.mx/avisos-de-privacidad-de-la-sebien/
          </a>
          , en la sección de{" "}
          <span style={{ fontWeight: 900 }}>“Avisos de Privacidad”</span>.
        </p>
      </Modal>
    </>
  );
};

export default RegisterButton;
